// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"344":"lang-uk-index-js","854":"lang-ru-index-js"}[chunkId] || chunkId) + "." + {"74":"6eb976e7","224":"0b63f39b","344":"b85421ef","603":"4ad7a693","708":"627937ac","854":"2bda3e49","884":"578f28ab","922":"d1083c91"}[chunkId] + ".js";
};